import classNames from 'classnames';
import { useResponsiveness } from './use-responsiveness';

/**
 * A custom hook to generate responsive class names based on the base class name.
 * @param {string} baseClass - The base class name.
 * @param {string} [mobileModifier] - MobileModifier class name appended to the base class when triggered.
 * @returns {string} A string of conditional class names.
 */
export const useResponsiveClassNames = (
  baseClass: string,
  mobileModifier?: string,
): string => {
  const { isMobile } = useResponsiveness();
  return classNames(baseClass, {
    [mobileModifier || `${baseClass}--mobile`]: isMobile,
  });
};

/**
 * A custom hook to generate conditional class names based on the base class name.
 * @param {string} baseClass - The base class name.
 * @param {string} [modifier] - Modifier class name appended to the base class when triggered.
 * @param {boolean} trigger - The condition to determine if the modifier should be applied.
 * @returns {string} A string of conditional class names.
 */
export const useConditionalClassNames = (
  baseClass: string,
  modifier: string,
  trigger: boolean,
): string => {
  return classNames(baseClass, {
    [`${baseClass}--${modifier}`]: trigger,
  });
};
